import { useContext } from "react";
import { useFormik } from "formik";
import FormField from "../../Input/FormField";
import Button from "../../Input/Button";
import LoginWrapper from "../LoginWrapper";
import axios from "axios";

import Context from "../../../../context";
import { useHistory } from "react-router-dom";
import { API_URL } from "../../../data/constants";

export default function PasswordResetPage() {
  const { contextState, setContextState } = useContext(Context);
  const history = useHistory();

  function validate(values) {
    const errors = {};
    if (!values.password1) {
      errors.password1 = "Required";
    } else if (
      !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/i.test(
        values.password1
      )
    ) {
      errors.password1 =
        "Minimum 8 characters, one number, one upper case letter, and one special character required";
    }

    if (!values.password2) {
      errors.password2 = "Required";
    } else if (values.password2 !== values.password1) {
      errors.password2 = "Passwords must match";
    }
    return errors;
  }
  const resetForm = useFormik({
    initialValues: {
      password1: "",
      password2: "",
    },
    validate,
    onSubmit: (values) => {
      axios
        .post(API_URL + "/Users/ResetPassword", {
          token: localStorage.getItem("resetToken"),
          password: values.password1,
          confirmPassword: values.password2,
        })
        .then((res) => {
          localStorage.removeItem("resetToken");
          history.push("/");
          setContextState({ ...contextState, loginActivePage: "login" });
        });
    },
  });

  return (
    <LoginWrapper>
      <h3 className="login-header">Create New Password</h3>
      <form className="login-form" onSubmit={resetForm.handleSubmit}>
        <FormField
          field="password1"
          type="password"
          name="New Password"
          form={resetForm}
        />
        <FormField
          field="password2"
          type="password"
          name="Re-enter New Password"
          form={resetForm}
        />
        <Button
          className="btn-fluid btn--green btn--bordered"
          type="submit"
          disabled={!(resetForm.dirty && resetForm.isValid)}
          text="Create New Password"
        />
      </form>
      <span
        className="login-link"
        onClick={() => {
          localStorage.removeItem("resetToken");
          history.push("/");
          window.location.reload(false);
        }}>
        Back to Login
      </span>
    </LoginWrapper>
  );
}
